import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';

const CreateExpenseButton: React.FunctionComponent = () => (
    <div className={classNames('text-right w-100')}>
        <Link to={Router.generate(routes.EXPENSE_CREATE)} className={`${'btn btn-success'}`}>
            <span>Create</span>
        </Link>
    </div>
);

export default CreateExpenseButton;
